// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"-link-button-linkWrapper-1Alxdn-","linkBox":"-link-button-linkBox-DkLpRn-"};